export enum UserWorkClockingAction {
  SingUp = 'sign-up',
  ClockIn = 'clock-in',
  EditSignUp = 'edit-sign-up',
  EditClockIn = 'edit-clock-in',
  EditClockOut = 'edit-clock-out',
  EditStore = 'edit-store',
  Delete = 'delete',
}
